import { useState } from "react";
import { useToast } from "../ToastContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ReactGA from 'react-ga4';

function DeleteAccountConfirmation() {
    const API_URL = process.env.REACT_APP_API_URL;

    const { showToast } = useToast();
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const email = localStorage.getItem("userEmail");

    const handleAccountDelete = async (e) => {
        e.preventDefault();

        if (password) {
            try {
                const response = await axios.delete(`${API_URL}/users/delete-account`, { data: { email, password } })
                if (response.data) {
                    //GA
                    ReactGA.event({
                        category: 'User',
                        action: 'delete_account',
                        label: 'Usunięcie konta przez użytkownika'
                    });

                    showToast(response.data.message, "success");
                    localStorage.clear();
                    navigate("/");
                } else {
                    showToast("Wystąpił błąd, spróbuj ponownie", "error")
                }
            } catch (error) {
                if (error.response && error.response.data) {
                    showToast(error.response.data.message, "error")
                } else {
                    showToast("Błąd połączenia z serwerem", "error")
                }
            }
        };
    }

    return (
        <div className="register-wrapper">
            <div className="register-card">
                <h2 className="register-title">
                    TRADI<span className="logo-highlight">WORLD</span>
                </h2>
                <p className="register-subtitle">Aby usunąć konto podaj do niego hasło:</p>

                <form onSubmit={handleAccountDelete} method='POST' className="register-form">
                    <div className="input-group">
                        <label htmlFor="password">Hasło</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="••••••••"
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="register-button">
                        Usuń konto
                    </button>
                </form>
            </div>
        </div>
    );

}
export default DeleteAccountConfirmation;